// extracted by mini-css-extract-plugin
export default {"dealerRoot":"Zg8n7"};